type TRedirect = { from: string | RegExp, to: string };

export const redirectByAuth: Record<'forAuthorized' | 'forUnauthorized', TRedirect[]> = {
    forAuthorized: [
        { from: '/', to: '/lk' },
        { from: '/user/login', to: '/lk' },
        { from:  '/bundles', to: '/lk/change-tariff' },
        { from:  new RegExp(/\/bundles\/(.+)/), to: '/lk/change-tariff' },
    ],
    forUnauthorized: [
        { from: '/lk/aboutdomrubonus', to: '/' },
        { from: '/lk/management/cancellation', to: '/lk/management' },
        { from: '/lk/settings/phone', to: '/' },
        { from: '/movix-pro', to: '/movix-new' },
        { from: '/domru-tv', to: '/movix-new' },
        { from:  new RegExp(/\/bundles\/(?!village)(.+)/), to: '/full-buy?tariffName=$1&monoTariff=false' },
        { from:  new RegExp(/\/bundles\/village(.+)/), to: '/internet/mono-village' },
    ],
};

export const rewrite: TRedirect[] = [
    // seo system files
    { from: '/robots.txt', to: '/api/robots.txt' },
    { from: '/9b25e45be0034d37876303e323bd7026.txt', to: '/api/indexNow.txt' },
    // static files
    { from: '/favicon.ico', to: '/static/favicon.ico' },
    { from: '/icon.svg', to: '/static/icon.svg' },
    { from: '/apple-touch-icon.png', to: '/static/apple-touch-icon.png' },
    { from: '/android-chrome-192x192.png', to: '/static/android-chrome-192x192.png' },
    { from: '/android-chrome-512x512.png', to: '/static/android-chrome-512x512.png' },
    { from: '/domru.webmanifest', to: '/static/domru.webmanifest' },
    {
        from: '/apple-developer-merchantid-domain-association.txt',
        to: '/static/apple-developer-merchantid-domain-association.txt',
    },
    // old domru static
    { from: '/policy.pdf', to: '/static/policy.pdf' },
    { from: new RegExp(/\/images\/(.+)/), to: '/static/domru-images/$1' },
    // iOS deeplinks
    { from: '/.well-known/apple-app-site-association', to: '/api/apple-app-site-association' },
    // Android deeplinks
    { from: '/.well-known/assetlinks.json', to: '/static/assetlinks.json' },
];

export const referrersWhiteList = [
    'dom.ru',
    'domru.ru',
    'r-one.io',
    'ertelecom.ru',
    'movix.ru',
];

export const withoutMiddlewaresList = [
    '/_next/static',
    '/_next/data',
    '/static',
    '/payments-response',
    '/api/lesta',
    '/api/csrf',
    '/chat',
];
